export default __webpack_public_path__ + "static/apple-icon-152x152-8dd87aea3a3fc597e69e2f0ecedcc64b.png";